import { TOUR_BASE_QUERY_KEY } from '@/features/dashboard/tours/api/toursApi.queryKeys.ts';

const TOUR_PARTICIPANT_CUSTOM_FIELDS_BASE_QUERY_KEY =
  'tourParticipantCustomFields';

export const tourParticipantCustomFieldsApiQueryKeys = {
  allForTour: (tourId: string) =>
    [
      TOUR_BASE_QUERY_KEY,
      tourId,
      TOUR_PARTICIPANT_CUSTOM_FIELDS_BASE_QUERY_KEY,
    ] as const,
};
